export class ReportPageController {
    constructor(XRayUtils, $filter, $timeout, $rootScope, $state, $stateParams, $scope, JFrogModal, JFrogGridFactory,
                uiGridConstants, ComponentsDao, xrayLicensesDao, SecurityReportsDao, TOOLTIPS, XRayUIStorage) {
        this.$state = $state;
        this.XRayUIStorage = XRayUIStorage;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.xrayUtils = XRayUtils;
        this.TOOLTIP = TOOLTIPS.reports;
        this.$filter = $filter;
        this.xrayLicensesDao = xrayLicensesDao;
        this.SecurityReportsDao = SecurityReportsDao;
        this.$scope = $scope;
        this.modal = JFrogModal;
        this.componentsDao = ComponentsDao;
        this.$stateParams = $stateParams;
        this.pageTitle = this.getTitle();
        this.jfrogGridFactory = JFrogGridFactory;
        this.uiGridConstants = uiGridConstants;


        this.setReportOptions();

    }// ctor

    setUnknownBtn(data) {
        let unknownLength = data.distribution.Unknown;
        let sum = _.sum(data.distribution);
        if (unknownLength === sum) {

            this.showUnknown = true;
            this.disableCheckbox = true;
        }
    }

    setStepSizes() {

        _.each(this.parsedSecData, (val, index) => {

            if (val.data.length == 1) {
                let max = _.max(val.data[0]);
                if (max > 50) {
                    let step = Math.ceil((parseInt(max / 5)) / 5) * 5;
                    this.parsedSecData[index].options.scales.yAxes[0].ticks.stepSize = step;
                }
            }// if it's Recent Graph
            else {
                var max = _.max(val.data);
                if (max > 50) {
                    let step = Math.ceil((parseInt(max / 5)) / 5) * 5;
                    this.parsedSecData[index].options.scales.yAxes[0].ticks.stepSize = step;
                }
            }// if it's Recent Graph


        });

    }

    setReportOptions() {
        this.Chartcolors = ['#bd3b1b', '#99bc58', '#e79723', '#55942c', '#820094'];

        if (this.$stateParams.reportType === 'license') {
            this.chartOptions = this.getCharOptions('licenseDist');
            this.CompliancechartOptions = this.getCharOptions('licenseCompliance');

            this.getLicenseReportsData();
            this.chartType = 'pie';
            this.defaultPagination = {
                compliance: 'unknown',
                direction: 'asc',
                num_of_rows: 10,
                order_by: 'licenses',
                page_num: 1
            };
            this.defaultDistPagination = {
                license: 'MIT',
                direction: 'asc',
                num_of_rows: 10,
                order_by: 'licenses',
                page_num: 1
            };
        }
        else if (this.$stateParams.reportType === 'security') {
            this.chartType = 'bar';


            this.recentVulPagination = {
                date: '',
                direction: 'asc',
                num_of_rows: 10,
                order_by: 'licenses',
                page_num: 1
            };

            this.recentComponentsPagination = {
                date: '',
                direction: 'asc',
                num_of_rows: 10,
                order_by: 'licenses',
                page_num: 1
            };


            this.topVulPagination = {
                id: '',
                direction: 'asc',
                num_of_rows: 10,
                order_by: 'licenses',
                page_num: 1
            };

            this.getSecurityReportsData();
            /*console.log(_.keys(this.security_returned_data.recentVulnerabilities));
             console.log(_.values(this.security_returned_data.recentVulnerabilities));*/


        }
    }

    getTitle() {

        switch (this.$stateParams.reportType) {
            case 'license':
                return 'License Report';
                break;

            case 'security':
                return 'Security Report';
                break;

            default:
                return 'Report';
                break;

        }
    }//get Title according to the value passed via the stateparams object

    showModal(chartType, obj) {
        this._createGrid(chartType, obj.text);
        let modalScope = this.$scope.$new();
        //console.log('The chart Type received is : ', chartType, 'The obj recieved is  ', obj);

        if (chartType === 'licenseCompliance') {
            //console.log('opening modal for compliance');
            modalScope.type = 'License Compliance';
            this.defaultPagination.compliance = obj.text;
            this.pagination = this.defaultPagination;
        }
        else if (chartType === 'licenseDist') {
            //console.log('opening modal for distribution');
            modalScope.type = 'License Distribution';
            this.defaultDistPagination.license = obj.text;
            this.pagination = this.defaultDistPagination;
        }
        else if (chartType === 'recent_vul') {
            modalScope.type = 'Recent Vulnerabilities';
            this.recentVulPagination.time = obj.text;
            this.pagination = this.recentVulPagination;
        }
        else if (chartType === 'top_vul') {
            modalScope.type = 'Top Vulnerabilities';
            this.topVulPagination.id = obj.text;

        }
        else if (chartType === 'top_artifacts') {
            modalScope.type = 'Top Artifacts';
            modalScope.pkgType = this.topArtifacts[_.findIndex(this.topArtifacts,
                {'name': obj.text})].package_type;
            modalScope.currentArt = this.topArtifacts[_.findIndex(this.topArtifacts, {'name': obj.text})];
            /*if (this.topArtifacts[_.findIndex(this.topArtifacts, {'name': obj.text})].version !== '') {
                modalScope.version = this.topArtifacts[_.findIndex(this.topArtifacts,
                    {'name': obj.text})].version;
            }*/
            this.topVulPagination.id = obj.text;

            //this.currentPackageType = this.topArtifacts[_.findIndex(this.topArtifacts, {'name':
            // obj.text})].package_type;

        }
        else if (chartType === 'recent_components') {
            modalScope.type = 'Recent Components';
            this.recentComponentsPagination.time = obj.text;
            this.pagination = this.recentComponentsPagination;
        }
        modalScope.licenseName = obj.text;
        modalScope.gridOptions = this.gridOptions;


        if (chartType !== 'top_vul') {
            if (obj.text !== 'No Data') {

                let options = {windowClass: 'reports-modal'};



                this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/show_report_grid_modal.html'), modalScope, 'lg', true, options).result.then(() => {
                        //console.log('modal loaded');
                    }
                )
            }
        } else {

            let index = _.findIndex(this.topVulnerabilities, {'summary': obj.text});

            modalScope.type = 'Top Vulnerabilities';
            modalScope.vulName = obj.text;

            this.SecurityReportsDao.getTopVul({index}).$promise.then((results) => {
                if (results.affected_components) {
                    results.affected_components = _.sortBy(results.affected_components, 'name');
                }
                modalScope.vulObj = results;
                this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/show_report_grid_top_vul_modal.html'), modalScope).result.then(() => {
                });
            });

        }
    }

    getParsedDate(dateToParse) {

        let date = new Date(dateToParse);
        return this.$filter('date')(date, 'MMM dd, yyyy');
    }

    /*  chart options function  */
    getCharOptions(chartType) {
        let options = {
            cutoutPercentage: 0,
            scales: {
                xAxes: [{
                    ticks: {
                        callback: function (value) {
                            //console.log('The value is ', value, 'The length is : ', value.length)
                            let finalLabel;
                            if (value === '') {
                                return 'No Data';
                            }

                            if (value.length > 11) {

                                finalLabel = value.substr(0, 11) + '...';
                            } else {
                                return value;
                            }

                            return finalLabel;//truncate
                        },
                    },
                    display: true

                }],
                yAxes: [{
                    ticks: {
                        min: 0,
                        stepSize: 5
                    }
                }]
            },
            tooltips: {

                callbacks: {
                    /*  label: function(tooltipItem,data) {
                     console.log(data.datasets[tooltipItem.datasetIndex]);
                     }*/

                    label: function (tooltipItem, data) {

                        let allData = data.datasets[tooltipItem.datasetIndex].data;
                        let tooltipLabel = data.labels[tooltipItem.index];
                        let tooltipData = allData[tooltipItem.index];
                        let total = 0;
                        for (let i in allData) {
                            total += allData[i];
                        }

                        let tooltipPercentage = Math.round((tooltipData / total) * 100);

                        if (chartType === 'licenseCompliance' || chartType === 'licenseDist') {

                            return tooltipLabel + ': ' + tooltipData + ' (' + tooltipPercentage + '%)';
                        }
                        else {
                            return tooltipData;
                        }


                    }
                },
                custom: (tooltip) => {

                    if (
                        !tooltip
                    ) {
                        return;
                    }

                    //console.log('the tooltio is !!!' ,tooltip.text );


                },
                bodyFontColor: '#fff',
                mode: 'single',
                bodyFontSize: 14,
                caretSize: 8
            },
            elements: {
                arc: {
                    borderColor: '#fff',
                    borderWidth: 2

                }

            }
            ,
            hover: {
                onHover: function (seg) {

                    if (seg.length) {
                        document.body.style.cursor = 'pointer';
                    } else {
                        document.body.style.cursor = 'default';
                    }

                }
            }

            ,
            onClick: (mouseevent, segment) => {

                if (segment[0]) {
                    //console.log('the segment', segment[0])
                    let current_clicked = segment[0]._view.label;

                    //console.log('get data for ' + chartType);
                    this.$scope.$apply();
                    if (chartType != 'security') {
                        this.sliceClick(chartType, segment);
                    }
                    else if (chartType === 'security') {

                    }

                }


            }
            ,
            title: {
                display: false,
                text: 'License Overview',
                fontSize: 20,
                fontColor: '#000'
            }
            ,
            legend: {


                display: true,
                labels: {
                    fontColor: '#000'

                }
                ,
                onClick: (mouseEvent, obj) => {

                    this.showModal(chartType, obj);

                }
                ,
                onHover: (mouseEvent, obj) => {
                    if (obj.length) {
                        document.body.style.cursor = 'pointer';
                    } else {
                        document.body.style.cursor = 'default';
                    }


                }
                ,
                position: 'bottom'
            }
            ,
            responsive: true,
            animation: {}
            ,

            tooltipEvents: [],
            tooltipCaretSize: 0,
            showTooltips: true


        }

        if (chartType !== 'licenseCompliance' && chartType !== 'licenseDist') {

            options.legend.display = false;
        }


        if (chartType === 'licenseDist' || chartType === 'licenseCompliance') {
            options.scales.xAxes = [{display: false}];
        }

        //options.scales.yAxes[0].ticks.stepSize = 40;

        return options;

    }


    /* End chart options function  */

    /* Grid creation functions */
    _getColumns(type, obj) {


        if (type === 'licenseDist' && obj === 'Other' || type === 'licenseCompliance' && obj !== 'unknown') {

            return [
                {
                    name: 'Component ID',
                    displayName: 'Component Name',
                    field: 'component_name',
                    cellTemplate: `<div ng-if="row.entity.pkg_type.toLowerCase() !== 'generic'" class="ui-grid-cell-contents"
                    ui-sref="components.details({componentID: row.entity.component_id.split('//')[0] + '//' + row.entity.component_name})"><a href="">{{row.entity.component_name}}</a></div><div ng-if="row.entity.pkg_type.toLowerCase() === 'generic'" class="ui-grid-cell-contents" ui-sref="components.details({componentID: row.entity.component_id})"><a href="">{{row.entity.component_name}}</a></div>`,
                    sort: {
                        direction: this.uiGridConstants.ASC
                    },
                    width: '35%'
                },
                {
                    name: 'Version',
                    displayName: 'Version',
                    field: 'component_version',
                    sortable: false,
                    cellTemplate: `<div class="ui-grid-cell-contents" ><a ng-bind-html="grid.appScope.ReportPage.extractVersion(row.entity.component_id,row.entity.component_name)" href=""></a></div>`,
                    width: '20%'
                },
                {
                    name: 'Package Type',
                    displayName: 'Package Type',
                    field: 'pkg_type',
                    width: '15%'
                },
                {
                    name: 'License Type',
                    displayName: 'License Type',
                    cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.licenses.join(', ')}}</div>`,
                    field: 'licenses',
                    width: '30%'
                }
            ]


        } else if (type === 'recent_vul' || type === 'top_vul') {

            return [
                {
                    enableSorting: false,
                    name: 'Summary',
                    displayName: 'Summary',
                    cellTemplate: `<div ng-if="row.entity.summary !== ''" class="ui-grid-cell-contents">{{row.entity.summary}}</div><div ng-if="row.entity.summary === ''" class="ui-grid-cell-contents">N/A</div>`,
                    field: 'summary',
                    width: '20%'
                },
                {
                    enableSorting: false,
                    name: 'Description',
                    displayName: 'Description',
                    field: 'description',
                    width: '35%'
                },
                {
                    enableSorting: false,
                    name: 'severity',
                    displayName: 'Severity',
                    field: 'severity',
                    cellTemplate: `<div  ng-class="[row.entity.severity.toLowerCase()]"class="severity grid-severity ui-grid-cell-contents">{{row.entity.severity |capitalizeFirst}}</div>`,
                    width: '10%'
                },
                {
                    enableSorting: false,
                    name: 'Infected Components',
                    displayName: 'Infected Components',
                    cellTemplate: `<div class="ui-grid-cell-contents"> <span ng-repeat="(key,val) in row.entity.affected_components" > {{val.name}}\n</span></div>`,
                    field: 'affected_components',
                    width: '15%'
                },

                {
                    enableSorting: false,
                    name: 'Created',
                    cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.created | date:'medium'}}</div>`,
                    displayName: 'Created',
                    field: 'created',
                    width: '20%'
                }
            ]

        }
        else if (type === 'recent_components') {

            return [
                {
                    name: 'Type',
                    displayName: 'Type',
                    cellTemplate: `<div style="height: 40px;width:90px;position:absolute" jf-tooltip="{{row.entity.package_type | capitalizeFirst}}" class="tooltip-ph"></div><div  style="text-align:center" jf-tooltip="{{row.entity.package_type}}" ng-class="'icon-' + grid.appScope.ReportPage.getIcon(row.entity.package_type)" class="ui-grid-cell-contents pkg-type-cell" ></div>`,
                    field: 'package_type',
                    width: '8%',
                    enableSorting: false
                },
                {
                    name: 'Component Name',
                    displayName: 'Component Name',
                    field: 'component_name',
                    cellTemplate: `<div ng-if="row.entity.package_type.toLowerCase() !== 'generic'" class="ui-grid-cell-contents" ui-sref="components.details({componentID: row.entity.component_id.split('//')[0] + '//' + row.entity.name,componentVersion:row.entity.version})"><a href="">{{row.entity.name}}</a></div><div ng-if="row.entity.package_type.toLowerCase() === 'generic'" class="ui-grid-cell-contents" ui-sref="components.details({componentID: row.entity.component_id})"><a href="">{{row.entity.name}}</a></div>`,
                    /* sort: {
                     direction: this.uiGridConstants.ASC
                     },*/
                    enableSorting: false,
                    width: '67%'
                },
                {
                    name: 'Version',
                    displayName: 'Version',
                    cellTemplate: `<div ng-if="row.entity.version !== ''" class="ui-grid-cell-contents">{{row.entity.version}}</div><div ng-if="row.entity.version === ''" class="ui-grid-cell-contents">N/A</div>`,
                    field: 'version',
                    enableSorting: false,
                    width: '10%'
                },
                {
                    name: 'Vulnerabilities',
                    displayName: 'Vulnerabilities',
                    cellTemplate: ` <div class="ui-grid-cell-contents"> <span>{{row.entity.vulnerabilities_count}}</span></div>`,
                    field: 'vulnerabilities_count',
                    enableSorting: false,
                    width: '15%'
                }

            ]

        } else if (type === 'top_artifacts') {

            return [
                {
                    enableSorting: false,
                    name: 'cve',
                    displayName: 'CVE',
                    cellTemplate: `<div  ng-if="row.entity.cves[0].cve" class="ui-grid-cell-contents">{{row.entity.cves[0].cve}}</div><div  ng-if="!row.entity.cves[0].cve" class="ui-grid-cell-contents">N/A</div>`,
                    field: 'cves[0].cve',
                    width: '15%'
                },
                {
                    enableSorting: false,
                    name: 'Summary',
                    cellTemplate: `<div ng-if="row.entity.summary !== ''" class="ui-grid-cell-contents">{{row.entity.summary}}</div><div ng-if="row.entity.summary === ''" class="ui-grid-cell-contents">N/A</div>`,
                    displayName: 'Summary',
                    field: 'summary',
                    width: '15%'
                },
                {
                    enableSorting: false,
                    name: 'Description',
                    cellTemplate: `<div  class="ui-grid-cell-contents">{{row.entity.description}}</div>`,
                    displayName: 'Description',
                    field: 'description',
                    width: '40%'
                },
                {
                    enableSorting: false,
                    name: 'Severity',
                    cellTemplate: `<div  ng-class="[row.entity.severity.toLowerCase()]" class="severity grid-severity ui-grid-cell-contents">{{row.entity.severity |capitalizeFirst}}</div>`,
                    displayName: 'Severity',
                    field: 'severity',
                    width: '15%'
                },
                {
                    enableSorting: false,
                    name: 'Created',
                    cellTemplate: `<div  class="ui-grid-cell-contents">{{row.entity.created | date:'medium'}}</div>`,
                    displayName: 'Created',
                    field: 'created',
                    width: '15%'
                }
            ]
        }

        else {

            return [
                {
                    name: 'Component Name',
                    displayName: 'Component Name',
                    field: 'component_name',
                    cellTemplate: `<div ng-if="row.entity.pkg_type.toLowerCase() !== 'generic'" class="ui-grid-cell-contents" ui-sref="components.details({componentID: row.entity.component_id.split('//')[0] + '//' + row.entity.component_name})"><a href="">{{row.entity.component_name}}</a></div><div ng-if="row.entity.pkg_type.toLowerCase() === 'generic'" class="ui-grid-cell-contents" ui-sref="components.details({componentID: row.entity.component_id})"><a href="">{{row.entity.component_name}}</a></div>`,
                    sort: {
                        direction: this.uiGridConstants.ASC
                    },
                    width: '33%'
                },
                {
                    name: 'Version',
                    displayName: 'Version',
                    field: 'component_version',
                    sortable: false,
                    cellTemplate: `<div class="ui-grid-cell-contents" ><a ng-bind-html="grid.appScope.ReportPage.extractVersion(row.entity.component_id,row.entity.component_name)" href=""></a></div>`,
                    width: '34%'
                },
                {
                    name: 'Package Type',
                    displayName: 'Package Type',
                    field: 'pkg_type',
                    width: '33%'
                }
            ]

        }

    }

    extractVersion(compId, compName) {

        if (compId) {
            let version = compId.substring(compId.indexOf(compName) + compName.length + 1);
            if (version == '') {
                return 'N/A';
            }
            return version;
        }

    }

    getIcon(pkgType) {
        if (pkgType.toLowerCase() === 'maven') {
            return 'pom';
        }
        if (pkgType.toLowerCase() === 'generic') {
            return 'general';
        }
        return pkgType.toLowerCase();
    }

    _createGrid(type, obj) {


        if (type === 'top_vul' || type === 'top_artifacts') {
            // creating a grid without server side pagination
            //console.log('the type is ',type);

            if (type === 'top_artifacts') {
                let indexKey;
                let data = _.pick(this.topArtifacts, (value, key, object) => {
                    if (value.name.trim() === obj.trim()) {
                        indexKey = this.topArtifactsIndexDictionary.indexOf(value.component_id);
                    }
                    return value;
                });
                //console.log('The Data for the grid : ',  data);

                if (typeof data[indexKey] !== 'undefined') {
                    //console.log('current Data is :',data[indexKey].vulnerabilities)
                    let numberPattern = /-?\d+\.\d+/;
                    //-?\d+(?:,\d+)*\.\d+

                    _.forEach(data[indexKey].vulnerabilities, function (value, key) {
                        //console.log('current key is :',key,'val is :',value.properties.cvss_v2);
                        //console.log('currently working on: ',data[indexKey].vulnerabilities[key])
                        if (value.properties) {
                            if (!value.properties.cvss_v2) {
                                let pluckedCVSS_V2 = _.map(data[indexKey].vulnerabilities[key].cves[0], 'cvss_v2');

                                if (pluckedCVSS_V2[0]) {
                                    data[indexKey].vulnerabilities[key].cves[0].cvss_v2 = pluckedCVSS_V2.match(
                                        /[-+]?\d*(\.(?=\d))?\d+/g)[0];
                                }
                            }
                        }

                    });


                    /*   data[indexKey].vulnerabilities = data[indexKey].vulnerabilities.filter((vul) => {

                     if (this._hasDetails(vul))
                     return vul
                     });*/
                    this.currnetArtifactIndex = indexKey;


                    this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
                        .setRowTemplate('default')
                        .setColumns(this._getColumns(type, obj))
                        .setRowsPerPage(10)
                        .setExternalPagination(
                            (pagination) => this.getResults(pagination, type, obj))
                        .setGridData([]);
                }

                //this.getResults({index: indexKey}, type, obj)
            }
            else {
                this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
                    .setRowTemplate('default')
                    .setColumns(this._getColumns(type, obj))
                    .setGridData(this.topVulnerabilities);
            }


        } else {

            this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
                .setRowTemplate('default')
                .setColumns(this._getColumns(type, obj))
                .setRowsPerPage(10)
                .setExternalPagination((pagination) => this.getResults(pagination, type, obj))
                .setGridData([]);

        }
    }

    setVulsTooltip(obj) {

        return _.map(obj, 'summary').join('\n');
    }

    getResults(pagination, reportType, obj) {

        pagination = pagination || this.defaultPagination;
        //_.extend(pagination);

        switch (reportType) {

            case 'licenseCompliance' :
                pagination.compliance = obj;
                break;

            case 'licenseDist' :
                pagination.license = obj;
                break;

            case 'recent_vul' :
                pagination.time = obj;
                break;
            case 'top_vul' :
                pagination.id = obj;
                break;
            case 'top_artifacts' :
                pagination.index = this.currnetArtifactIndex;
                break;
            case 'recent_components' :
                pagination.time = obj;
                break;
        }

        let promise;
        if (reportType === 'licenseCompliance' || reportType === 'licenseDist') {
            promise = this.xrayLicensesDao.getComponents(pagination).$promise;
        } else if (reportType === 'recent_vul') {


            promise = this.SecurityReportsDao.getRecentVul(pagination).$promise;
        }
        else if (reportType === 'recent_components') {


            promise = this.SecurityReportsDao.getRecentComponents(pagination).$promise;
        }
        else if (reportType === 'top_vul') {

            promise = this.SecurityReportsDao.getTopVul(pagination).$promise;
        }
        else if (reportType === 'top_artifacts') {
            promise = this.SecurityReportsDao.getTopArt(pagination).$promise;

        }


        promise.then((results) => {
            this.results = results;
            this.resultsSummaryString = ` - ${results.length} Components`;
            if (!results.length) {
            }
        })


        return promise;
    }

    sliceClick(chartType, el) {
        //console.log('fetch data for the following  for :  ' + chartType, el[0]._view.label);

        let obj = {text: el[0]._view.label};

        if (chartType === 'recent_vul') {
            obj.text = _.keys(this.recentVulnerabilites)[el[0]._index];
            if (this.recentVulnerabilites[obj.text] === 0) {
                return false;
            }

        } else if (chartType === 'recent_components') {
            obj.text = _.keys(this.recentComponents)[el[0]._index];
            if (this.recentComponents[obj.text] === 0) {
                return false;
            }
        }

        this.showModal(chartType, obj);

    }

    getLicenseReportsData() {
        this.xrayLicensesDao.getReports().$promise.then((results) => {
            this.orignalResults = results;
            this.setUnknownBtn(results);

            _.each(this.orignalResults.distribution, (val, key) => {
                if (val == 0) {
                    delete this.orignalResults.distribution[key];
                }
            })

            _.each(this.orignalResults.compliance, (val, key) => {
                if (val == 0) {
                    delete this.orignalResults.compliance[key];
                    if (key == 'banned') {
                        this.Chartcolors = ['#99bc58', '#bd3b1b', '#e79723', '#55942c', '#820094'];
                    }
                }
            })
            this.licenseReportsData = this.arrangeReportsData(this.orignalResults);

        })
    }

    getSecurityReportsData() {

        this.SecurityReportsDao.getReports().$promise.then((results) => {
            this.topArtifactsIndexDictionary = _.map(results.top_artifacts, 'component_id');
            results.top_artifacts = _.sortBy(results.top_artifacts, 'vulnerabilities_count');


            this.buildData(results);
        });

    }

    buildData(results) {
        let tmpArr = [];
        //this foreach creating the summary unique
        _.forEach(results.top_vulnerabilities, function (value, key) {
            if (value.summary === '') {
                value.summary = 'No Data';
            }
            value.summary = value.summary + '(#' + key + ')';
            tmpArr.push(value);
        });
        this.topVulnerabilities = tmpArr;
        this.recentVulnerabilites = results.recent_vulnerabilities;
        this.topArtifacts = results.top_artifacts;
        _.each(this.topArtifacts, (val, key) => {
            if (val.version && val.version != '') {
                val.name = val.name + ':' + val.version;
            }
        })
        ;

        this.recentComponents = results.recent_components;
        let topVulTransform = {};
        let recentVulTransform = {};
        let topArtifacts = {};
        let recentComponents = {};
        let i = 0;
        /* Top Vulnerabilities Data transform */
        //topVulTransform.data = _.map(this.topVulnerabilities, 'affected_components.length');
        topVulTransform.data = [];
        _.each(this.topVulnerabilities, (val, key) => {
            topVulTransform.data.push(val.total_affected_artifacts);
        });

        topVulTransform.labels = _.map(this.topVulnerabilities, 'summary');
        topVulTransform.options = this.getCharOptions('top_vul');
        topVulTransform.type = 'Top 5 Vulnerabilities';
        topVulTransform.help = this.TOOLTIP.top_vul;

        if (topVulTransform.data.length < 5) {
            for (let i = topVulTransform.data.length; topVulTransform.data.length < 5; i++) {

                topVulTransform.data[i] = 0;
                topVulTransform.labels[i] = 'No Data';
            }
        }

        let mergedObj = topVulTransform.data.map((val, index) => {
            return {key: val, value: topVulTransform.labels[index]};
        });

        topVulTransform.labels = _.map(mergedObj, 'value').reverse();
        topVulTransform.data = _.map(mergedObj, 'key').reverse();

        /* End Top Vulnerabilities Data transform */

        /* Recent Vulnerabilities Data transform */
        recentVulTransform.data = [_.values(this.recentVulnerabilites)];
        recentVulTransform.labels = _.keys(this.recentVulnerabilites);
        recentVulTransform.type = 'Recent Vulnerabilities (Last 5 Weeks)';
        recentVulTransform.help = this.TOOLTIP.recent_vul;
        recentVulTransform.options = this.getCharOptions('recent_vul');
        /* End  Recent Vulnerabilities Data transform */


        /*Top Artficats Data transform */

        topArtifacts.data = _.map(this.topArtifacts, 'vulnerabilities_count');
        topArtifacts.labels = _.map(this.topArtifacts, 'name');
        topArtifacts.versions = _.map(this.topArtifacts, 'version');


        if (topArtifacts.data.length < 5) {
            for (let i = topArtifacts.data.length; topArtifacts.data.length < 5; i++) {

                topArtifacts.data[i] = 0;
                topArtifacts.labels[i] = 'No Data';
            }

        }
        topArtifacts.type = 'Top 5 Artifacts';
        topArtifacts.help = this.TOOLTIP.top_artifacts;
        topArtifacts.options = this.getCharOptions('top_artifacts');
        /* End  top Artifacts Data transform */


        /* Recent Components Data transform */
        recentComponents.data = [_.values(this.recentComponents)];
        recentComponents.labels = _.keys(this.recentComponents);
        recentComponents.type = 'Recent Components (Last 5 Weeks)';
        recentComponents.help = this.TOOLTIP.recent_components;
        recentComponents.options = this.getCharOptions('recent_components');
        /* End  Recent Components  Data transform */
        this.parsedSecData = [];
        this.parsedSecData.push(recentVulTransform, recentComponents, topVulTransform, topArtifacts);

        this.setStepSizes();

    }

    /* End Grid creation functions  */

    _getFilteredArtifacts() {


        let vulCount = [];
        let newdata = _.map(this.topArtifacts, 'vulnerabilities');

        _.each(newdata, (val, index) => {

            let count = 0;

            _.each(val, (innerval, index) => {

                if (this._hasDetails(innerval)) {
                    count++;
                }

            });//inner each
            vulCount.push(count);
        });
        return vulCount;
    }

    _hasDetails(vul) {

        return vul.summary !== '' && vul.description !== '';
    }

    arrangeReportsData(obj) {
        let objArr = [];
        _.forEach(obj, (value, key) => {
            let tmpObj = {};

            if (key === 'distribution' || key === 'compliance' || key === 'recentVulnerabilities' || key === 'topVulnerabilities') {

                if (key === 'distribution') {
                    tmpObj.type = 'License Distribution';
                    tmpObj.help = this.TOOLTIP.dist;
                }

                else if (key === 'compliance') {
                    tmpObj.type = 'License Compliance';
                    tmpObj.help = this.TOOLTIP.compliance;
                }

                else if (key === 'recentVulnerabilities') {
                    tmpObj.type = 'Recent Vulnerabilities';
                } else if (key === 'topVulnerabilities') {
                    tmpObj.type = 'Top Vulnerabilities';
                }
                tmpObj.title = key;
                let labels = [];
                let data = [];
                _.forEach(value, (value, key) => {

                    if (tmpObj.type === 'Recent Vulnerabilities') {
                        tmpObj.options = this.getCharOptions('recent_vul');
                        tmpObj.help = this.TOOLTIP.recent_vul;
                        labels.push(key);
                    }
                    else if (tmpObj.type === 'Top Vulnerabilities') {
                        tmpObj.options = this.getCharOptions('top_vul');
                        tmpObj.help = this.TOOLTIP.top_vul;

                        labels.push(key);
                    }
                    else {
                        if (this.showUnknown && key.toLowerCase() === 'unknown' || key.toLowerCase() !== 'unknown') {
                            //console.log('The Key is ', key)
                            labels.push(key);
                        }

                    }
                    if (this.showUnknown && key.toLowerCase() === 'unknown' || key.toLowerCase() !== 'unknown') {
                        data.push(value);
                    }
                });

                tmpObj.labels = labels;
                tmpObj.data = data;
                let sum = 0;
                _.forEach(data, function (value, key) {
                    sum = sum + value;
                });
                tmpObj.dataSum = sum;

                objArr.push(tmpObj);


            }

        });


        return objArr;
    }

    securityChartClick(event) {


    }

    securityChartHover(event) {

        if (event.length) {
            document.body.style.cursor = 'pointer';
        } else {
            document.body.style.cursor = 'default';
        }
    }

    getAffected(arr) {

        return _.map(arr, 'id').join('\n');
    }

    cleanVer(str) {
        let compId = '';
        if (str) {
            if (str.substr(0, 7) == 'generic') {
                return str;
            } else {
                return str.substr(0, str.lastIndexOf(':'));
            }
        }
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/reports/report-page.controller.js